import { ApiError } from "./apiFetch";

export function loginHttpError(response) {
  const error = new ApiError(response.status, "LOGIN_HTTP_ERROR");
  error.retryAfter = response.headers.get("Retry-After");
  return error;
}

function retryMinutes(value) {
  if (!value) return null;
  const raw = String(value).trim();
  const seconds = /^\d+$/.test(raw)
    ? Number(raw)
    : (Date.parse(raw) - Date.now()) / 1000;
  return Number.isFinite(seconds) && seconds > 0 ? Math.ceil(seconds / 60) : null;
}

export function getLoginErrorMessage(error, phase = "login") {
  const profile = phase === "profile";
  const prefix = profile ? "Не удалось загрузить профиль. " : "";

  if (phase === "storage" || error?.name === "SecurityError" || error?.name === "QuotaExceededError") {
    return "Не удалось сохранить данные входа в браузере. Разрешите хранение данных сайта и попробуйте ещё раз.";
  }
  if (error?.status === 401) {
    return profile
      ? "Не удалось подтвердить сессию. Попробуйте войти ещё раз."
      : "Неправильный логин или пароль.";
  }
  if (error?.status === 403) {
    return "Доступ запрещён. Обратитесь к администратору.";
  }
  if (error?.status === 429) {
    const minutes = retryMinutes(error.retryAfter);
    return `${prefix}Слишком много попыток входа. ${minutes ? `Повторите через ${minutes} мин.` : "Попробуйте позже."}`;
  }
  if (error?.status === 400 || error?.status === 422) {
    return profile
      ? `${prefix}Сервер отклонил запрос. Попробуйте войти ещё раз.`
      : "Проверьте, что логин и пароль заполнены корректно.";
  }
  if (error?.status === 408 || error?.status === 504 || error?.name === "AbortError" || error?.name === "TimeoutError") {
    return `${prefix}Сервер не ответил вовремя. Попробуйте ещё раз.`;
  }
  if (error?.status === 404) {
    return `${prefix}Сервис входа недоступен. Обратитесь к администратору.`;
  }
  if (error?.status === 502 || error?.status === 503) {
    return `${prefix}Сервис временно недоступен. Попробуйте позже.`;
  }
  if (error?.status >= 500) {
    return `${prefix}Ошибка сервера. Попробуйте позже. Если ошибка повторяется, обратитесь к администратору.`;
  }
  if (error?.code === "INVALID_AUTH_RESPONSE" || error instanceof SyntaxError) {
    return `${prefix}Сервер вернул некорректный ответ. Попробуйте позже.`;
  }
  if ((phase === "login" || profile) && error instanceof TypeError) {
    return `${prefix}Не удалось связаться с сервером. Проверьте подключение к интернету и попробуйте ещё раз.`;
  }
  return profile
    ? `${prefix}Попробуйте войти ещё раз.`
    : "Не удалось выполнить вход. Попробуйте ещё раз. Если ошибка повторяется, обратитесь к администратору.";
}
